"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTooltipValue = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const utilities_1 = require("../../utilities");
const formatTooltipValue = (value, decimals, type) => {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return 'No Data';
  }
  return decimals ? (0, utilities_1.valueFormat)({
    params: {
      format: type
    }
  })(value, {
    decimals
  }) : (0, utilities_1.valueFormat)({
    params: {
      format: type,
      basic: true
    }
  })(value);
};
exports.formatTooltipValue = formatTooltipValue;
const TooltipContent = _ref => {
  let {
    title,
    subtitle,
    color,
    value,
    units,
    annotation,
    decimals,
    type
  } = _ref;
  return react_1.default.createElement(react_1.default.Fragment, null, title && react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-title'],
    style: {
      color
    }
  }, title), subtitle && react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-subtitle']
  }, subtitle), react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-grid']
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-row']
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-value'],
    style: {
      color
    }
  }, (0, exports.formatTooltipValue)(value, decimals, type), units && ` ${units}`)), annotation && react_1.default.createElement(react_1.default.Fragment, null, annotation.title && react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-row']
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-annotation-title']
  }, annotation.title)), annotation.text && react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-row']
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['tooltip-annotation-text']
  }, annotation.text)))));
};
TooltipContent.propTypes = {
  /**
   * Bolded title at the top of the component.
   * Affect by `color`.
   */
  title: prop_types_1.node,
  /**
   * Normal font weight subtitle.
   * Color is set to `#4d4d4d`.
   */
  subtitle: prop_types_1.node,
  /**
   * Usually a formatted number. Largest font size item in the component.
   * Affect by `color`.
   */
  value: prop_types_1.node,
  /**
   * Sets the color of `title` and `value`
   */
  color: prop_types_1.string,
  /**
   * Sets the unit string
   */
  units: prop_types_1.string,
  /**
   * Annotation that goes under the rest of the content.
   * `title` is bolded.
   * Color is set to `#4d4d4d`.
   */
  annotation: (0, prop_types_1.shape)({
    title: prop_types_1.string,
    text: prop_types_1.string
  }),
  /**
   * Number of decimal places in tooltip value.
   * Set this to undefined for auto formatting.
   */
  decimals: prop_types_1.number,
  /**
   * Custom type for tooltip value formatting.
   */
  type: prop_types_1.string
};
exports.default = TooltipContent;